import './assets/css/vendor/bootstrap.min.css';

import { configureAxios } from './services/API/core';
import awsAPI from './services/API/aws';
configureAxios();
awsAPI.getAWSCredential();

export const color = 'light.purplemonster';

const render = () => {
  import(`./assets/css/sass/themes/main-theme.scss`).then(() => {
    require('./AppRenderer');
  });
};
render();
